<template>
        <div>
                <el-dialog
                        :visible.sync="dialogVisible"
                        width="70%"
                        title="查看"
                        append-to-body
                        :modal-append-to-body='false'
                        :show-close='true'
                        :close-on-press-escape='false'
                        :close-on-click-modal="false"
                       
                        >

                        <avue-form
                                :option="option"
                                v-model="form"
                                v-if="dialogVisible"
                                ref="form"
                                
                                @submit="(form,done)=>applyFor(1,form,done)"
                                @error="formError"
                        >
                        <template slot="warehouseId">
                                <el-select v-model="form.warehouseId"
                                        :disabled="disabled"
                                >
                                        <el-option
                                                v-for="item in warehouseList"
                                                :key="item"
                                                :value="item.id"
                                                :label="item.name"
                                        >

                                        </el-option>
                                </el-select>
                        </template>
                        <template slot="requisitionUser">
                                <avue-input-tree
                                        v-model="form.requisitionUser"
                                        :dic="userlist"
                                >

                                </avue-input-tree>
                        </template>
                        <template slot="requisitionDept">
                                <el-select v-model="form.requisitionDept"
                                        :disabled="disabled"
                                >
                                        <el-option
                                                v-for="item in deptList"
                                                :key="item"
                                                :value="item.id"
                                                :label="item.fullName"
                                        >

                                        </el-option>
                                </el-select>
                        </template>
                        
                                <template slot="menuForm">
                                        <el-button 
                                         :loading="loading"
                                        @click="applyFor(3)">
                                                取消
                                        </el-button>
                                </template>
                                <template slot="dataList">
                                        <div>
                                          <ConsumableSelector
                                                :showSum='true'
                                                ref="cs"
                                                :columns="csColumns"
                                                :numberMode="'mormal'"
                                                :numberKey="csNumKey"
                                                :priceKey="csPriceKey"
                                                :data.sync="csData"
                                                :priceMode="'normal'"
                                                :editable="false"
                                                :scene="'out'"
                                                />
                                        </div>
                                       
                                </template>
                        </avue-form>
                        
                </el-dialog>
               
        </div>
</template>
<script>
import formOption from "./outbound-record-form";
import ConsumableSelector from '@/components/consumable-selector/index';

import {confirm,getDetail,getWarehouseListApply,treeDeptsByIds} from "@/api/crmedical/warehouse/outbound/record.js";
 

import {
  getProjectList,
  getWarehouseList,
  getDict,
  consumableList,
  getBusinessNo
} from "@/api/crmedical/warehouse/index.js";

import {mapGetters} from "vuex";
import treeVue from '../../../../../../packages/config/tree.vue';
export default {
        components:{
                ConsumableSelector
        },
        props:{

        },
        data(){
                
                return{
                        confirmBtn:false,
                        deptList:[],
                        disabled:true,
                        loading:false,
                        option:formOption,
                        dialogVisible:false,
                        csData:[],
                        csColumns: [
                                { label: "序号", prop: "", type: "index", width: 50 },
                                { label: "物品", prop: "name" },
                                { label: "编号", prop: "code" },
                                { label: "分类", prop: "typeName" },
                                { label: "单位", prop: "measuringUnitName" },
                                { label: "品牌", prop: "brand" },
                                { label: "规格", prop: "specification" },
                                { label: "生产商", prop: "manufacturer" },
                                { label: "出库单价", prop: "price" },
                                { label: "出库数量", prop: "outboundNum" },
                                { label: "出库金额", prop: "priceOutboundNum" },
                                
                                {
                                label: "剩余可数量领用",
                                prop: "surplus",
                                maxCheck: true,
                                hide: true,
                                },
                        ],
                        pageLoading: false,
                        prjectList: [],
                        userlist:[],
                        warehouseList: [],
                        warehouseInboundTypeList: [],
                        inboundStatusList: [],
                        dicts: {},
                        editable: false, 
                        form: {
                                projectId: "",
                                warehouseId: "",
                                type: "",
                                inboundStatus: "",
                                inboundNo: "",
                                linkNo: "",
                                id:'',
                        },
                        addDialogVisible: false,
                        data: [], //入库单列表
                        csData: [],
                        submitFlag:true,
                        mode:'',
                        csNumKey:'outboundNum',
                }
        },
        created() {
                this.fetchData();
        },
        watch:{
                'form.projectId'(val,oldval){
                        if(!this.form.projectId){
                                return;
                        }
                        // this.csData = [];
                        this.getWarehouseList();
                },
                'form.warehouseId'(val,oldval){
                        if(this.title == '查看'){
                                return;
                        }
                        if(val){
                                // this.viewUpdateConsumableList(this.csData);
                        }
                       
                },

               
        },
         computed: {
            ...mapGetters(['userInfo']),
            
           
        },
        methods:{
                // 根据当前登录人获取科室
                treeDeptsByIds(){
                        
                        treeDeptsByIds().then(res=>{
                                this.deptList = res.data;
                                if(this.title=='申请'){
                                        this.form.requisitionDept = this.deptList[0]?this.deptList[0].id:'';
                                }
                        })
                },
                // 打开弹窗页面
                openDialog(data){
                        this.treeDeptsByIds();
                        this.form={
                                warehouseId:'',
                                projectId:'',
                                id:data.data.id,
                        };
                        this.submitFlag = true;
                        this.csData = [];

                        let projeCtcolumn  = this.findObject(this.option.column, "projectId");
                        projeCtcolumn.dicData = data.dicData.projectIdDictDataList;
                        console.log( data.dicData.userlist)
                        data.dicData.userlist.forEach(item=>{
                                item.label = item.realNameAndPhone;
                                item.value = item.userId;
                        })
                        this.userlist = data.dicData.userlist;
                        
                        this.title = '查看';
                        this.getDetail(data.data.id,(detail)=>{
                                this.form = detail;
                                this.form.projectId = detail.projectId;
                                this.form.requisitionDept =detail.requisitionDept;
                                this.form.requisitionUser =detail.requisitionUser;
                                this.form.remark = detail.remark;
                                this.form.requisitionNo = detail.requisitionNo;
                                this.form.requisitionUserNamePhone = detail.requisitionUserPhone ? detail.requisitionUserName+ '('+ detail.requisitionUserPhone+')':detail.requisitionUserName;

                                if(detail.outboundStatus==1){
                                        this.option.submitBtn = true;
                                        // this.confirmBtn = true;
                                }else{
                                       this.option.submitBtn = false;  
                                }

                                this.form.outboundUserNamePhone = detail.outboundUserPhone? detail.outboundUserName+'('+ detail.outboundUserPhone +')':detail.outboundUserName;
                                detail.consumableList.forEach(ele=>{
                                        ele.priceOutboundNum = ele.price*ele.outboundNum
                                })
                               
                                this.csData = detail.consumableList
                                
                                
                                this.dialogVisible = true; 
                              


                        })

                        

                        
                        
                },
                getDetail(id,callback){
                        getDetail({id:id}).then(res=>{
                                callback(res.data);
                        })
                },
                formError(done){
                        done();
                },
                // 保存 提交    
                applyFor(type,form,done){
                      
                        if(type==3){
                                this.dialogVisible = false;
                                this.$emit('onLoad');
                                return;
                        }

                        confirm({id:this.form.id}).then(res=>{
                                if(res.success){
                                        this.$message({
                                                message: '确认领料成功',
                                                type: 'success'
                                        });
                                        this.dialogVisible = false;
                                        this.$emit('onLoad');
                                }else{
                                        this.$message({
                                                message: res.msg,
                                                type: 'warning'
                                        });
                                }
                        })


                        
                },

                // 获取仓库列表 科室列表
                getWarehouseList(){
                     
                        getWarehouseListApply({projectId:this.form.projectId}).then(res=>{
 
                                this.warehouseList = res.data;
                        })
                     
                },
              
                
                loadData(query, resolve) {
                        query.name = query.text;
                        const params = { ...query, projectId: this.form.projectId };
                        const columns = [
                                { label: "分类", prop: "typeName" },
                                { label: "编号", prop: "code" },
                                { label: "名称", prop: "name" },
                                { label: "计量单位", prop: "measuringUnitName" },
                                { label: "品牌", prop: "brand" },
                                { label: "规格", prop: "specification" },
                        ];
                        consumableList(params).then((res) => {
                                res.data.records.forEach((element) => {
                                element.id = "";
                                });
                                resolve(res.data, columns);
                        });
                },
                loadPrice(query, resolve) {
                        setTimeout(() => {
                                resolve(10.0);
                        }, 500);
                        },
                        async fetchData() {
                        this.pageLoading = true;
                        try {
                                //projectList
                                const resProjectList = await getProjectList();
                                this.prjectList = resProjectList.data;
                                this.form.projectId = this.prjectList[0]
                                ? this.prjectList[0].id
                                : "";
                                //warehouseList
                                const resWarehouseList = await getWarehouseList({
                                projectId: this.form.projectId,
                                });
                                this.warehouseList = resWarehouseList.data;

                                this.form.warehouseId = this.warehouseList[0]
                                ? this.warehouseList[0].id
                                : "";
                                //type && status
                                const dicts = await Promise.all([
                                getDict({ code: "warehouse_inbound_type" }),
                                getDict({ code: "inbound_status" }),
                                ]);
                                this.warehouseInboundTypeList = dicts[0].data;
                                this.form.type = this.warehouseInboundTypeList[0].dictKey;
                                this.inboundStatusList = dicts[1].data;
                                this.form.inboundStatus = this.inboundStatusList[0].dictKey;
                                //load list
                                // this.loadList();
                        } catch (err) {
                        }
                        this.pageLoading = false;
                },
        }
}
</script>
